import { render, staticRenderFns } from "./ProposalHorizontalButton.vue?vue&type=template&id=465b699c"
import script from "./ProposalHorizontalButton.vue?vue&type=script&lang=js"
export * from "./ProposalHorizontalButton.vue?vue&type=script&lang=js"
import style0 from "./ProposalHorizontalButton.vue?vue&type=style&index=0&id=465b699c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports